import type React from 'react';
import { SkeletonPage, Layout, SkeletonTabs, Card, SkeletonDisplayText, InlineStack, SkeletonBodyText, BlockStack } from '@shopify/polaris';

/**
 * Widget设置页面骨架屏组件
 */
const WidgetSkeleton: React.FC = () => {
  return (
    <SkeletonPage primaryAction>
      <Layout>
        <SkeletonTabs />
        <Layout.Section>
          <BlockStack gap='400'>
            <Card>
              <SkeletonDisplayText size='small' />
            </Card>
            <Card>
              <BlockStack gap='400'>
                <SkeletonDisplayText size='small' />
                <SkeletonBodyText />
              </BlockStack>
            </Card>
            <Card>
              <BlockStack gap='400'>
                <SkeletonDisplayText size='small' />
                <SkeletonBodyText />
              </BlockStack>
            </Card>
            <Card>
              <BlockStack gap='400'>
                <SkeletonDisplayText size='small' />
                <SkeletonBodyText />
                <SkeletonDisplayText size='small' />
                <SkeletonBodyText />
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.Section>
        <Layout.Section variant='oneThird'>
          <Card>
            <BlockStack gap='400'>
              <SkeletonDisplayText size='small' />
              <div style={{width: '100%', height: '450px', backgroundColor: '#EDEEEF',borderRadius: '0.5rem'}}></div>
            </BlockStack>
          </Card>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
};

export default WidgetSkeleton; 